import { ReturnStruct } from "src/app/shared/structs/return.struct";

export class BillingStatusRequest extends ReturnStruct {
    public idBillingStatus: number;
}